import { MultiSelect, SingleSelect } from '@predoc/cow';
import { useGetCurrentUserProfileAccess } from '../hooks/usersApi';

export const ProfileAccessDropdown = ({
  enabled,
  values,
  onChange,
  disabled,
}: {
  enabled: boolean;
  values: string[];
  onChange: (values: string[]) => void;
  disabled: boolean;
}) => {
  const { data: profileAccessOptions = [] } = useGetCurrentUserProfileAccess({
    enabled,
  });

  return (
    <MultiSelect
      options={profileAccessOptions}
      values={values}
      handleChange={onChange}
      placeholder="Select profiles..."
      className="w-full"
      disabled={disabled}
      maxVisible={2}
    />
  );
};

export const ProfileSingleSelectDropdown = ({
  value,
  onChange,
  disabled,
  options,
}: {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  options: Array<{
    value: string;
    label: string;
    avatarType: string;
    disabled: boolean;
  }>;
}) => {
  return (
    <SingleSelect
      options={options}
      value={value}
      handleChange={onChange}
      placeholder="Select a profile..."
      className="w-full"
      disabled={disabled}
    />
  );
};
